module.exports = __webpack_public_path__ + "img/bg.056cba9c.webp";